import { render } from "./import.vue?vue&type=template&id=2ef24a1a&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"

import "./import.vue?vue&type=style&index=0&id=2ef24a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef24a1a"]])

export default __exports__